import { render, staticRenderFns } from "./UploadingVideo.vue?vue&type=template&id=bb105ff2"
import script from "./UploadingVideo.vue?vue&type=script&lang=js"
export * from "./UploadingVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports